import m from "mithril";
import MessageProvider from "../../../MessageProvider";
import { BookingDetail} from "../../../Models";
import { Location } from "../../../Models";
import './FindBookingPage.css'
import BookingSearchFormCard from "./BookingSearchFormCard";
import BookingSearchCriteria from "../../../states/BookingSearchCriteria";
import BookingSearchFormState, { BookingLookupResultState } from "../../../states/BookingSearchFormState";
import BookingSummaryComponent from "./BookingSummaryComponent";

interface Attrs {    
    bookings: BookingDetail[],
    locations : Location[],
    messageProvider: MessageProvider;
    bookingSearchFormState: BookingSearchFormState;
    bookingLookupResultState: BookingLookupResultState;
    isMobile?: boolean;
    onSearch: (searchCriteria:BookingSearchCriteria) => void;
    onViewDetails: (booking: BookingDetail) => void;
    onLocationClick?: () => void;
    onDateRangePickerClick?: () => void;
}

function FindBookingPage(): m.Component<Attrs> {

    return {
        oncreate(vnode){
            console.log("on create : " + vnode.attrs.bookingLookupResultState);
            //document.body.style.overflow = "hidden";
            if(vnode.attrs.bookingLookupResultState == 'SHOW_RESULT'){
                const bookingResultElem = document.getElementById('bookingResult');
                if(bookingResultElem != null){
                    window.scrollTo({
                        top: bookingResultElem.getBoundingClientRect().y + window.scrollY,
                        behavior: 'smooth',
                    });
                } 
            } 
        },
        view(vnode) {    
            const {bookings, locations, messageProvider, bookingSearchFormState, bookingLookupResultState, isMobile, onSearch, onViewDetails, onLocationClick, onDateRangePickerClick} = vnode.attrs;    

            let getNumberOfNight = (checkInDate:string, checkOutDate: string): number => {
                let differentInTime = new Date(checkOutDate).getTime() - new Date(checkInDate).getTime();
                return differentInTime / (1000 * 3600 * 24);
            };
            return [
                m("div", {id: "custom-scroll-id"}, [
                    m("h5.pt-4 font-weight-bold d-none d-md-block text-primary text-center", messageProvider.get("find_your_booking")),
                    m("strong.d-block d-md-none mt-3 mb-2 text-dark px-3", messageProvider.get("find_your_booking")),
                    m("p.text-muted px-3 ", { class: (isMobile)? "": "text-center"}, messageProvider.get("find_your_booking_description")),
                    m("div.mx-2", [
                        m(BookingSearchFormCard, {
                            messageProvider : messageProvider,
                            locations: locations,
                            bookingSearchFormState: bookingSearchFormState,
                            bookingLookupResultState: bookingLookupResultState,
                            isMobile: isMobile,
                            onSearch: function(searchCriteria){
                                onSearch(searchCriteria);
                            },
                            onLocationClick: () => {
                                if(onLocationClick != undefined){
                                    onLocationClick();
                                }
                            },
                            onDateRangePickerClick: () => {
                                if(onDateRangePickerClick != undefined){
                                    onDateRangePickerClick();
                                }
                            }
                        })
                    ]),
                    (bookingLookupResultState == 'SHOW_RESULT')?
                    [
                        m("div.mt-5 mx-2", {id: "bookingResult"}, [
                            m("span", "Result : "),
                            m("span.font-weight-bold text-dark", bookings.length),
                            m("span", " Booking(s) Found.")
                        ]),
                        m("div",{}, [                
                                bookings.map((booking,index) => {
                                    return [
                                        m("div.card m-2 rounded-16", 
                                            m("div.card-body", {
                                                onclick: () => {
                                                    onViewDetails(booking)
                                                }
                                            }, [
                                                m(BookingSummaryComponent, {
                                                    booking: booking,
                                                    messageProvider: messageProvider,
                                                    onViewDetails: function(booking){
                                                        document.body.style.overflow = "auto";
                                                        onViewDetails(booking);
                                                    }
                                                }),
                                            ])
                                        )
                                    ]
                                })
                        ])
                    ]:null      
                ])
            ]
        }
    }
}

export default FindBookingPage;

